import useAuth from "./useAuth";
import axios from "../api/axios";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {

    const response = await axios.get("refresh-token", {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    setAuth((prev) => {
      return {
        ...prev,
        username: response.data.username,
        name: response.data.name,
        roles: response.data.role,
        accessToken: response.data.accessToken,
        level_id: response.data.level_id,
        level_name: response.data.level_name,
        category: response.data.category,

        parent_name: response.data.parent_name,
        parent_id: response.data.parent_id,
      };
    });
    return response.data.accessToken;
  };

  return refresh;
};

export default useRefreshToken;
